// Page Not Found

import React from "react";

// Default
import { useNavigate } from "react-router-dom";

// Mui
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

// Custom
import ContainedButton from "../../forms/button/ContainedButton";

const PageNotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      <Box
        component="img"
        src="https://cdn-icons-png.flaticon.com/512/2748/2748558.png"
        alt="404 Illustration"
        sx={{ width: "50%", mb: 3 }}
      />
      <Typography variant="h3" gutterBottom>
        404 - Page Not Found
      </Typography>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        The page you are looking for doesn't exist or has been moved.
      </Typography>
      <ContainedButton
        label={"Go to Home"}
        sx={{
          width: "fit-content",
          mt: 2,
          fontWeight: 600,
          color: "#ffffff",
        }}
        onClick={() => navigate("dashboard-360")}
      />
    </Container>
  );
};

export default PageNotFound;
